const STORAGE_KEY = 'descripio_signup_variant';
const VALID_VARIANTS = ['C', 'D'];

export const getSignupVariant = ({ searchParams, storage } = {}) => {
  const override = searchParams?.get?.('v');
  if (VALID_VARIANTS.includes(override)) {
    return override;
  }

  const safeStorage = storage || (typeof window !== 'undefined' ? window.localStorage : undefined);

  try {
    const stored = safeStorage?.getItem?.(STORAGE_KEY);
    if (VALID_VARIANTS.includes(stored)) {
      return stored;
    }

    const assigned = Math.random() < 0.5 ? 'C' : 'D';
    safeStorage?.setItem?.(STORAGE_KEY, assigned);
    return assigned;
  } catch (_) {
    return 'C';
  }
};

export const SIGNUP_VARIANT_STORAGE_KEY = STORAGE_KEY;
